module.exports = __webpack_public_path__ + "static/media/soto.16ff035a.png";